import type { SVGProps } from "react";
export const ArrowBackIosNew = (props: SVGProps<SVGSVGElement>) => (
	<svg
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		aria-hidden={true}
		{...props}
	>
		<path
			d="M15.9999 21.6538L6.34619 12L15.9999 2.34625L17.4192 3.7655L9.18444 12L17.4192 20.2345L15.9999 21.6538Z"
			fill="currentColor"
		/>
	</svg>
);
